
import $ from 'jquery';
import general from './general';


let rtn = {};

const elementCollection = $('.section.brace.work'),
      breakpoint = general.getBreakpoint();


const setup = () => {

    elementCollection.each(function() {

        const 
              el = $(this),
              elIndex = elementCollection.index(el) + 5,
              asideCollection = el.find('.aside'),
              articleCollection = el.find('.article'),
              divCollection = el.find('.aside .figure div'),
              imgCollection = el.find('.aside .figure div img'),
              firstDiv = divCollection.first(),
              firstImgHeight = Math.round(firstDiv.find('img').height());


              firstDiv.addClass('active');

              if (breakpoint.width >= breakpoint.device.desktop) {
                asideCollection.height(firstImgHeight);
                articleCollection.height(firstImgHeight);
                el.height(firstImgHeight);
                imgCollection.height(firstImgHeight);
              }

              el.addClass('active');

              animate(divCollection, parseInt(elIndex * '1600'));

              //setInterval(animate, parseInt(elIndex * '1600'), divCollection);

             
            

    })

}


const animate = (divCollection, timer) => {

    let active = divCollection.filter('.active'),
          next = active.next();

          if (next.length < 1) {
            next = divCollection.first();
          }
          
        

    setTimeout(() => {
        
        active.removeClass('active');
        next.addClass('active');
        
        animate(active.parent().find('div'), timer);
        

    }, timer);


    

    /*divCollection.each(function() {
        $(this).toggleClass('active');
    })*/

}



rtn.init = () => {

    if (elementCollection.length > 0) {
        setup();
    }

}


module.exports = rtn;



// WEBPACK FOOTER //
// ./js/service/work-animate-img.js